export default function RegisterHero() {
  return (
    <section className="w-full bg-white pt-24 pb-0 border-b border-gray-100">
      <div className="max-w-5xl mx-auto px-6">
        <div className="py-10">
          <div className="flex items-center gap-3 mb-4">
            <span
              className="text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full"
              style={{ backgroundColor: 'rgba(46,125,107,0.1)', color: '#2E7D6B' }}
            >
              FAMILY CAREGIVER REGISTRATION
            </span>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug mb-3">
            <span style={{ color: '#2E7D6B' }}>가족간병 등록</span> 신청하기
          </h1>
          <div
            className="rounded-xl px-5 py-4 text-sm leading-relaxed"
            style={{ backgroundColor: '#f0f9f6', borderLeft: '4px solid #2E7D6B' }}
          >
            <p className="text-gray-700 font-medium mb-1">
              간병보험(가족간병) 청구 시 가족간병 등록을 반드시 먼저 하셔야 보험금 청구가 가능합니다.
            </p>
            <p className="text-gray-500 text-xs">
              입원 전, 입원 당일에 가족간병 등록을 하셔야 하며, <strong className="text-gray-700">가족간병 등록은 무료</strong>입니다.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
